import React, { useContext } from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ThemeContext } from 'styled-components';
import { useTheme } from "../../../../styles/ThemeProvider";
import IconNight from "../../../../assets/Images/Icons/IconNight";
import IconDay from "../../../../assets/Images/Icons/IconDay";

interface BtnDarkModeToggleProps {
    open?: boolean;
}

const BtnDarkModeToggle: React.FC<BtnDarkModeToggleProps> = React.memo(({ open = false }) => {
    const { toggleTheme, theme: themeName } = useTheme();
    const theme = useContext(ThemeContext);

    // dark mode enabled
    return (
        <ListItemButton
            onClick={toggleTheme}
            sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
            }}
        >
            <ListItemIcon
                sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: theme.colors.text
                }}
            >
                {
                    themeName === "light"
                        ? <IconDay size={28}/>
                        : <IconNight size={28}/>
                }
            </ListItemIcon>
        </ListItemButton>
    )
});

BtnDarkModeToggle.displayName = 'BtnDarkModeToggle';

export default BtnDarkModeToggle;
